// extracted by mini-css-extract-plugin
module.exports = {"item":"jQ","dark":"jR","light":"jS","toggle":"jT"};